import React from 'react'
import * as st from '~/assets/styl/Differentials.module.styl'
import { Tabs, Button } from '~/components'
import SVG from './svg'
import { useLanguage } from '~/hooks'

export default function Differentials() {
  const { t } = useLanguage()
  return (
    <section className={st.core}>
      <Tabs
        items={[
          t('Differentials.tabs.1'),
          t('Differentials.tabs.2'),
          t('Differentials.tabs.3'),
        ]}
      >
        <div className={st.contentBox}>
          <div>
            <h3>
              BIM <br />
              Building <br />
              Information <br />
              Modeling
            </h3>
            <p>
              {t('Differentials.modelInformation')}
              <br />
              <br />
              {t('Differentials.theProcess')}
              <br />
              <br />
              {t('Differentials.implementation')}
            </p>
          </div>

          <SVG />

          <div>
            <h3>
              {t('Differentials.subtitle.1')}
              <br />
              {t('Differentials.subtitle.2')}
            </h3>
            <div>
              <p>{t('Differentials.findSolution')}</p>
              <Button
                href="https://www.youtube.com/watch?v=EmrZb-BdGoc&ab_channel=DimasConstru%C3%A7%C3%B5es"
                external
                outlined
              >
                {t('Differentials.watchTheTestimonials')}
              </Button>
            </div>
          </div>
        </div>

        <div className={st.contentBox}>
          <ul>
            <li>{t('Differentials.management')}</li>
            <li>{t('Differentials.control')}</li>
            <li>{t('Differentials.sustainability')}</li>
            <li>{t('Differentials.automatedControl')}</li>
            <li>{t('Differentials.digitalProjects')}</li>
            <li>{t('Differentials.platform')}</li>
            <li>{t('Differentials.weCreate')}</li>
            <li>{t('Differentials.promotion')}</li>
            <li>{t('Differentials.speed')}</li>
            <li>{t('Differentials.methodology')}</li>
          </ul>

          <div>
            <h3>
              {t('Differentials.subtitle.1')} <br />
              {t('Differentials.subtitle.2')}
            </h3>
            <div>
              <p>{t('Differentials.findSolution')}</p>
              <Button
                href="https://www.youtube.com/watch?v=EmrZb-BdGoc&ab_channel=DimasConstru%C3%A7%C3%B5es"
                external
                outlined
              >
                {t('Differentials.watchTheTestimonials')}
              </Button>
            </div>
          </div>
        </div>

        <div className={st.contentBox}>
          <div>
            <h3>Easyhome</h3>
            <div>
              <p>
                {t('Differentials.theEasyHome')
                  .split('\n')
                  .map((paragraph, index) => (
                    <React.Fragment key={index}>
                      {index > 0 && (
                        <>
                          <br />
                          <br />
                        </>
                      )}
                      {paragraph.trim()}
                    </React.Fragment>
                  ))}
              </p>
            </div>
          </div>

          <div>
            <h3>
              {t('Differentials.subtitle.1')} <br />
              {t('Differentials.subtitle.2')}
            </h3>
            <div>
              <p>{t('Differentials.findOutHow')}</p>
              <Button
                href="https://www.youtube.com/watch?v=EmrZb-BdGoc&ab_channel=DimasConstru%C3%A7%C3%B5es"
                external
                outlined
              >
                {t('Differentials.watchTheTestimonials')}
              </Button>
            </div>
          </div>
        </div>
      </Tabs>
    </section>
  )
}
